import {
  MessageResponseDto,
  GetTransactionDto,
  EditTransactionDto,
  TransactionControllerGet200Response,
  TransactionApiFp,
  DeleteTransactionDto,
  AddTransactionDto,
  TransactionControllerDashboard200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransactionModel = TransactionControllerGet200Response;
export type GetDashboardResponseTransactionModel =
  TransactionControllerDashboard200Response;
export type GetTransactionModel = GetTransactionDto;
export type MutateResponseTransactionModel = MessageResponseDto;
export type CreateTransactionModel = AddTransactionDto;
export type UpdateTransactionModel = EditTransactionDto;
export type DeleteTransactionModel = DeleteTransactionDto;

export const apiTransactionFp = TransactionApiFp(apiConfig);
export const getTransactionController =
  apiTransactionFp.transactionControllerGet;
export const createTransactionController =
  apiTransactionFp.transactionControllerCreate;
export const updateTransactionController =
  apiTransactionFp.transactionControllerEdit;
export const deleteTransactionController =
  apiTransactionFp.transactionControllerDelete;
export const completeTransactionController =
  apiTransactionFp.transactionControllerComplete;
export const cancelTransactionController =
  apiTransactionFp.transactionControllerCancel;
export const payTransactionController =
  apiTransactionFp.transactionControllerPaid;
export const dashboardTransactionController =
  apiTransactionFp.transactionControllerDashboard;

export const QueryKeyTransaction = QueryKey.Transaction;

export interface DashboardSummaryItem {
  label: string;
  value: number;
}

export interface ServiceSummaryData {
  total_kids: number;
  service_revenue: number;
  addon_revenue: number;
  grand_total: number;
}

export interface ServiceBreakdownAddon {
  item_name: string;
  quantity: number;
  amount: number;
  total: number;
}

export interface ServiceBreakdownItem {
  service_name: string;
  rate: number;
  quantity: number;
  total: number;
  addons: ServiceBreakdownAddon[];
}

export interface DashboardTransactionData {
  summary: DashboardSummaryItem[];
  service_summary: ServiceSummaryData;
  service_breakdown: ServiceBreakdownItem[];
}
